export default __webpack_public_path__ + "static/media/slot-m.6beb6d89.svg";